import { render } from "./DuihuanAmount.vue?vue&type=template&id=0d4ecb34&scoped=true"
import script from "./DuihuanAmount.vue?vue&type=script&lang=js"
export * from "./DuihuanAmount.vue?vue&type=script&lang=js"

import "./DuihuanAmount.vue?vue&type=style&index=0&id=0d4ecb34&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4ecb34"]])

export default __exports__